import sound from './die.wav';export default sound;